var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/AdvertisingBanner/AdvertisingBanner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/AdvertisingBanner/AdvertisingBanner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var t_4;
t_4 = 11;
frame.set("ADVERTISING_HOME_1", t_4, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_HOME_1", t_4);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_HOME_1", t_4);
}
output += "\n";
var t_5;
t_5 = 12;
frame.set("ADVERTISING_HOME_2", t_5, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_HOME_2", t_5);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_HOME_2", t_5);
}
output += "\n";
var t_6;
t_6 = 13;
frame.set("ADVERTISING_AWARDS_1", t_6, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_AWARDS_1", t_6);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_AWARDS_1", t_6);
}
output += "\n";
var t_7;
t_7 = 14;
frame.set("ADVERTISING_AWARDS_2", t_7, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_AWARDS_2", t_7);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_AWARDS_2", t_7);
}
output += "\n";
var t_8;
t_8 = 15;
frame.set("ADVERTISING_ADGAWARDS_1", t_8, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_ADGAWARDS_1", t_8);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_ADGAWARDS_1", t_8);
}
output += "\n";
var t_9;
t_9 = 16;
frame.set("ADVERTISING_ADGAWARDS_2", t_9, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_ADGAWARDS_2", t_9);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_ADGAWARDS_2", t_9);
}
output += "\n";
var t_10;
t_10 = 17;
frame.set("ADVERTISING_EVENTS_1", t_10, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_EVENTS_1", t_10);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_EVENTS_1", t_10);
}
output += "\n";
var t_11;
t_11 = 18;
frame.set("ADVERTISING_EVENTS_2", t_11, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_EVENTS_2", t_11);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_EVENTS_2", t_11);
}
output += "\n";
var t_12;
t_12 = 19;
frame.set("ADVERTISING_PERSPECTIVE_1", t_12, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_PERSPECTIVE_1", t_12);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_PERSPECTIVE_1", t_12);
}
output += "\n";
var t_13;
t_13 = 20;
frame.set("ADVERTISING_PERSPECTIVE_2", t_13, true);
if(frame.topLevel) {
context.setVariable("ADVERTISING_PERSPECTIVE_2", t_13);
}
if(frame.topLevel) {
context.addExport("ADVERTISING_PERSPECTIVE_2", t_13);
}
output += "\n\n";
var macro_t_14 = runtime.makeMacro(
[], 
["data", "size", "position"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("size", Object.prototype.hasOwnProperty.call(kwargs, "size") ? kwargs["size"] : "");frame.set("position", Object.prototype.hasOwnProperty.call(kwargs, "position") ? kwargs["position"] : "");var t_15 = "";t_15 += "\n    <div class=\"AdvertisingBanner\" data-size=\"";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "size"), env.opts.autoescape);
t_15 += "\">\n        ";
frame = frame.push();
var t_18 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("banner", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_15 += "\n            <a class=\"AdvertisingBanner-banner u-skipUrlParser ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")) {
t_15 += "AdvertisingBanner-banner--active";
;
}
t_15 += "\" href=\"";
t_15 += runtime.suppressValue(runtime.memberLookup((t_19),"link"), env.opts.autoescape);
t_15 += "\" data-params=\"";
t_15 += runtime.suppressValue(env.getFilter("tojson").call(context, t_19), env.opts.autoescape);
t_15 += "\" data-position=\"";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "position"), env.opts.autoescape);
t_15 += "\" target=\"_blank\">\n                <img src=\"";
t_15 += runtime.suppressValue(runtime.memberLookup((t_19),"img"), env.opts.autoescape);
t_15 += "\">\n            </a>\n        ";
;
}
}
frame = frame.pop();
t_15 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_15);
});
context.addExport("AdvertisingBanner");
context.setVariable("AdvertisingBanner", macro_t_14);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/AdvertisingBanner/AdvertisingBanner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AdvertisingBanner/AdvertisingBanner.jinja
// module id = 35
// module chunks = 0